module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_directing_arrow_white-9ddec888e59b1ff851df495922d58246.svg";